<template>
  <div class="step-2-section rounded-lg border border-gray-200 p-4 mb-6 shadow-sm"
    v-if="payload.length > 5"
    :class="{ 'bg-gray-50': !steps[1], 'bg-white': steps[1] }">
    <div class="section-heading mb-0">
      <span class="section-heading-number">2</span>
      {{ $t('message.shapeSelectionHeading') }}
    </div>
    <p class="help-text">{{ $t('message.shapeSelectionHelp') }}</p>

    <div v-if="steps[1]" class="mb-3">
      <select id="chooseShape" :value="shapeSelected" @change="$emit('update:shapeSelected', $event.target.value); $emit('figure-change')"
        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        aria-label="{{ $t('message.shapes') }}" :disabled="payload.length < 5">
        <option value="" disabled selected>{{ $t('message.selectShape') }}</option>
        <option v-for="(item, index) in commondata.menu.shapes[computedLocale]" :key="index" :value="item.name">
          {{ item.displayLabel }}
        </option>
      </select>

      <div v-if="firstMethodLength > 0" class="mt-4">
        <label for="methodOne" class="block text-sm font-medium text-gray-700">{{ $t('message.methodOne')
        }}</label>
        <select id="methodOne" :value="firstMethodSelected" @change="$emit('update:firstMethodSelected', $event.target.value); $emit('first-method-select')"
          class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option value="" disabled selected>{{ $t('message.selectMethod') }}</option>
          <option v-for="(item, index) in firstMethod" :key="index" :value="index">
            {{ item.method_label }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="additionalMethodLength > 0" class="mt-4">
      <label for="methodTwo" class="block text-sm font-medium text-gray-700">{{ $t("message.methodTwo") }}</label>
      <select id="methodTwo" :value="additionalMethodSelected" @change="$emit('update:additionalMethodSelected', $event.target.value)"
        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <option value="" disabled selected>{{ $t('message.selectAdditionalMethod') }}</option>
        <option v-for="(item, index) in additionalMethod" :key="index" :value="item.method_additional_name">
          {{ item.method_additional_label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step2_ShapeSelection',
  props: {
    payload: String,
    steps: Object,
    shapeSelected: String,
    firstMethodSelected: String,
    additionalMethodSelected: String,
    commondata: Object,
    computedLocale: String,
    firstMethodLength: Number,
    additionalMethodLength: Number,
    firstMethod: Object,
    additionalMethod: Object
  }
}
</script>
